import '../../../libs/backbone/backbone.ajaxq.adapter.ts';
import Handlebars from "handlebars";

import NavBarTopView from 'navbarTopView';
import FooterView from 'footerView';

import LoginView from "../views/login.view.ts";
import RegisterView from "../views/register.view.ts";
import ActivateUserView from "../views/activateUser.view.ts";
import ForgotPasswordView from "../views/forgotPassword.view.ts";
import ResetPasswordView from "../views/resetPassword.view.ts";
import ThirdPartyAuthenticationView from "../views/thirdPartyAuthentication.view.ts";

import i18n from "l10n";



export default Backbone.Router.extend({
	routes: {
		"": "loginRoute",
		"Login": "loginRoute",
		"Register": "registerRoute",
        "ForgotPassword": "forgotPasswordRoute",
        "ResetPassword/(:userHash)": "resetPasswordRoute",
        "VerifyUsername/(:userHash)": "verifyUsername",
        "VerifyEmail/(:userHash)": "verifyEmail",
        "Activate/(:userHash)": "activateUserRoute",
        "ThirdPartyAuthentication/(:provider)": "thirdPartyAuthenticationRoute",
        "ThirdPartyAuthentication/(:provider)/msgError": "thirdPartyAuthenticationErrorRoute",
		"(:anywhere)": "404Route"
	},
	loggedIn: false,
	userData: null,
	initialize: function (options) {
		self = this;
		this.loggedIn = options ? options.loggedIn : false;
		this.userData = options ? options.userData : null;

    },
    "404Route": function() {
        //todo: show 404 page
    },
    "403Route": function() {
        //todo: show 403 page
    },
    loginRoute: function() {
        if(this.loggedIn) {
            window.open("store.html", "_self");
            return;
        }

        this.clearView();
        this.createTheNavBars();
        this.view = new LoginView();
    },
    registerRoute: function () {
        this.clearView();
        this.createTheNavBars();
        this.view = new RegisterView({});
    },
    activateUserRoute: function (userHash) {
        this.clearView();
        this.createTheNavBars();
        this.view = new ActivateUserView({userHash: userHash});
    },
    forgotPasswordRoute: function () {
        this.clearView();
        this.createTheNavBars();
        this.view = new ForgotPasswordView();
    },
    thirdPartyAuthenticationRoute: function (provider) {
        this.clearView();
        this.createTheNavBars();
        this.view = new ThirdPartyAuthenticationView({provider: provider});
	},
    resetPasswordRoute: function (userHash) {
        this.clearView();
        this.createTheNavBars();
        this.view = new ResetPasswordView({userHash: userHash});
    },
    verifyUsername: function(userHash) {
        this.clearView();
        this.createTheNavBars();
        this.view = new LoginView({userHash: userHash, type: 'username'});
    },
    verifyEmail: function(userHash) {
        this.clearView();
        this.createTheNavBars();
        this.view = new LoginView({userHash: userHash, type: 'email'});
    },
    createTheNavBars: function() {
		this.footer = new FooterView();
		this.navbartop = new NavBarTopView({"userData": this.userData, "page": "login"});
	},
	createInfoViews: function() {
	    this.mainInfo = new MainInfoView();
	},
	clearView: function(){
		if(this.view){
			$.ajaxq.abort("DefaultQueue");

			this.view.stopListening();
			this.view.$el.empty();

			if(this.view.clearView)
				this.view.clearView();

			this.view.undelegateEvents();

			delete this.view;

			$("body").scrollTop(0);
		}

		var infoViews = [
		    this.navbartop,
		    this.footer,
		    this.mainInfo
		];

        $.each(infoViews, function(i, view) {
            if(view) {
                view.stopListening();
                view.undelegateEvents();
                view.$el.empty();
                delete view.source;
            }
        });
	}
});

